type Row = string[];
type Data = Row[];

export interface WishesData {
  Name: string;
  Attendance: string;
  People: string;
  Wishes: string;
  Time: string;
}

export const normalizeDataWishes = (rawData: Data): WishesData[] => {
  const columnTitles: Row = rawData[0];
  const data: Data = rawData.slice(1);

  const normalizedData: WishesData[] = data.map((row: Row) => {
    const normalizedRow: WishesData = {} as WishesData;
    columnTitles.forEach((title, index) => {
      normalizedRow[title as keyof WishesData] = row[index];
    });
    return normalizedRow;
  });

  return normalizedData.reverse();
};
